import apiCaller from '@/api/index';

export async function getLabelInfoApi(labelName: string) {
  const response = await apiCaller.get(`/labels/:name`, {
    params: { name: labelName }
  }, {});
  return response.data;
}

export async function getRedirectUrlApi(pattern: string) {
    const response = await apiCaller.get(`/labels/redirect`, {
        query: { pattern }
    }, {});
    return response.data;
}
